
// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// import './multidropdown.css';

// export default function MultiSeledDropdown({
//     width,
//     label,
//     selected,
//     setSelected,
//     options,
//     customWidth,
//     customTop,
//     isRequired,
//     style,
//     className,
//     showSelectAll,
//     onDropdownClose,
//     disabled = false,
// }) {
//     const [isActive, setIsActive] = useState(false);
//     const dropdownRef = useRef(null);

//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setIsActive(false);
//                 if (onDropdownClose) onDropdownClose(); // Trigger API call after dropdown closes
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [dropdownRef, onDropdownClose]);

//     const handleClick = (option) => {
//         const isSelected = selected.includes(option.id);
//         if (isSelected) {
//             setSelected(selected.filter((id) => id !== option.id));
//         } else {
//             setSelected([...selected, option.id]);
//         }
//     };

//     const handleSelectAll = () => {
//         if (selected.length === options.length) {
//             setSelected([]); // Unselect all
//         } else {
//             setSelected(options.map((option) => option.id)); // Select all
//         }
//     };


//     return (
//         <div
//             className={`dropdown-CB ${className}`}
//             style={{ width, ...style, opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? "none" : "auto" }}
//             // style={{ width, ...style }}
//         >
//             <label className="dropdown-CB-label">
//                 {label}
//                 {isRequired && <span>*</span>}
//             </label>
//             {/* <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}> */}
//             <div className="dropdown-btn" onClick={() => { if (!disabled) setIsActive(!isActive); }}>
//                 <div
//                     className="selected-options"
//                     style={{
//                         maxWidth: "200px",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         color: selected.length === 0 ? "grey" : "#6A6A6A", // Change color conditionally
//                     }}
//                 >
//                     {selected.length > 0
//                         ? options
//                             .filter((option) => selected.includes(option.id))
//                             .map((option) => option.label)
//                             .join(", ")
//                         : ""}
//                 </div>
//                 <img src={DropDownIcon} alt="dropdown-icon" />
//             </div>
//             {isActive && (
//                 <div
//                     className="dropdown-content-CBV2"
//                     style={{ width: customWidth, top: customTop }}
//                     ref={dropdownRef}
//                 >
//                     {showSelectAll && options.length > 0 && (
//                         <div className="dropdown-item-CBV2" style={{display: "flex", justifyItems: 'center'}}>
//                             {/* <input
//                                 type="checkbox"
//                                 className="delete-question-checkbox-dqc"
//                                 checked={selected.length > 0 && selected.length === options.length}
//                                 onChange={handleSelectAll}
//                             /> */}
//                             <input
//                                 type="checkbox"
//                                 className="delete-question-checkbox-dqc"
//                                 checked={selected.length > 0 && selected.length === options.length}
//                                 onChange={handleSelectAll}
//                                 disabled={disabled}
//                                 />
//                             <label style={{ marginLeft: "8px" }} onClick={handleSelectAll}>
//                                 Select All
//                             </label>
//                         </div>
//                     )}
//                     {options.map((option) => (
//                         <div key={option.id} className="dropdown-item-CBV2" style={{display: "flex", justifyItems: 'center'}}>
//                             <input
//                                 type="checkbox"
//                                 className="delete-question-checkbox-dqc"
//                                 checked={selected.includes(option.id)}
//                                 onChange={() => handleClick(option)}
//                             />
//                             {/* <label
//                                 style={{ marginLeft: "8px" }}
//                                 onClick={() => handleClick(option)}
//                             >
//                                 {option.label}
//                             </label> */}
//                             <label
//                                 style={{ marginLeft: "8px", cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.6 : 1 }}
//                                 onClick={() => { if (!disabled) handleClick(option); }}
//                                 >
//                                 {option.label}
//                                 </label>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// }





// code with placeholder values
import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
import './multidropdown.css';

export default function MultiSeledDropdown({
    width,
    label,
    selected = [],
    setSelected,
    options = [],
    customWidth,
    customTop,
    isRequired,
    style,
    className,
    showSelectAll,
    onDropdownClose,
    disabled = false,
    autoSelectAll = false, 
    placeholder = "Select", 
}) {
    const [isActive, setIsActive] = useState(false);
    const dropdownRef = useRef(null);
    const hasAutoSelected = useRef(false); // Track if auto-select has happened

    // Auto-select all options when options are first loaded (only once)
    useEffect(() => {
        if (autoSelectAll && options.length > 0 && Array.isArray(selected) && selected.length === 0 && !hasAutoSelected.current) {
            setSelected(options.map((option) => option.id));
            hasAutoSelected.current = true;
        }
    }, [options, autoSelectAll, selected, setSelected]);

    // Reset the auto-select flag when options change (e.g., course change)
    useEffect(() => {
        if (options.length === 0) {
            hasAutoSelected.current = false;
        }
    }, [options]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsActive(false);
                if (onDropdownClose) onDropdownClose();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef, onDropdownClose]);

    const handleClick = (option) => {
        const selArray = Array.isArray(selected) ? selected : [];
        const isSelected = selArray.some(id => String(id) === String(option.id));
        
        if (isSelected) {
            setSelected(selArray.filter((id) => String(id) !== String(option.id)));
        } else {
            setSelected([...selArray, option.id]);
        }
    };

    const handleSelectAll = () => {
        const selArray = Array.isArray(selected) ? selected : [];
        const allIds = (options || []).map((option) => option.id);
        const areAllSelected = allIds.length > 0 && allIds.every(id => selArray.some(s => String(s) === String(id)));

        if (areAllSelected) {
            setSelected([]); // Unselect all - no restrictions
        } else {
            setSelected(allIds); // Select all
        }
    };

    const selectedLabels = () => {
        const selArray = Array.isArray(selected) ? selected : [];
        if (selArray.length === 0) return "";
        return (options || [])
            .filter((option) => selArray.some(id => String(id) === String(option.id)))
            .map((option) => option.label)
            .join(", ");
    };

    return (
        <div
            className={`dropdown-CB ${className || ""}`}
            style={{ width, ...style, opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? "none" : "auto", position: "relative" }}
        >
            <label className="dropdown-CB-label">
                {label}
                {isRequired && <span>*</span>}
            </label>
            <div
                className="dropdown-btn"
                onClick={() => { if (!disabled) setIsActive(!isActive); }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); if (!disabled) setIsActive(!isActive); } }}
                aria-expanded={isActive}
            >
                <div
                    className="selected-options"
                    style={{
                        maxWidth: "200px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: (Array.isArray(selected) && selected.length === 0) ? "grey" : "#6A6A6A",
                    }}
                >
                    {Array.isArray(selected) && selected.length > 0
                        ? selectedLabels()
                        : placeholder}
                </div>
                <img src={DropDownIcon} alt="dropdown-icon" />
            </div>

            {isActive && (
                <div
                    className="dropdown-content-CBV2"
                    style={{ width: customWidth, top: customTop }}
                    ref={dropdownRef}
                >
                    {showSelectAll && options.length > 0 && (
                        <div className="dropdown-item-CBV2" style={{display: "flex", alignItems: 'center', padding: '8px 10px'}}>
                            <input
                                type="checkbox"
                                className="delete-question-checkbox-dqc"
                                checked={Array.isArray(selected) && (options.length > 0) && (Array.isArray(selected) && selected.length === options.length)}
                                onChange={handleSelectAll}
                                disabled={disabled}
                            />
                            <label 
                                style={{ marginLeft: "8px", cursor: disabled ? "not-allowed" : "pointer" }} 
                                onClick={() => { if (!disabled) handleSelectAll(); }}
                            >
                                Select All
                            </label>
                        </div>
                    )}

                    {options.map((option) => {
                        const selArray = Array.isArray(selected) ? selected : [];
                        const checked = selArray.some(id => String(id) === String(option.id));
                        return (
                            <div key={option.id} className="dropdown-item-CBV2" style={{display: "flex", alignItems: 'center', padding: '8px 10px'}}>
                                <input
                                    type="checkbox"
                                    className="delete-question-checkbox-dqc"
                                    checked={checked}
                                    onChange={() => handleClick(option)}
                                    disabled={disabled}
                                />
                                <label
                                    style={{ 
                                        marginLeft: "8px", 
                                        cursor: disabled ? "not-allowed" : "pointer", 
                                        opacity: disabled ? 0.6 : 1 
                                    }}
                                    onClick={() => { if (!disabled) handleClick(option); }}
                                >
                                    {option.label}
                                </label>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
